import { Box, Flex, Heading, Text, Button, VStack } from "@chakra-ui/react";

interface VideoSectionProps {
  title: string;
  subtitle: string;
  description: string;
  videoUrl: string;
  ctaText?: string;
  ctaLink?: string;
}

const VideoSection: React.FC<VideoSectionProps> = ({
  title,
  subtitle,
  description,
  videoUrl,
  ctaText,
  ctaLink,
}) => {
  return (
    <Box
      as="section"
      bg="gray.50"
      py={{ base: 12, md: 20 }}
      px={{ base: 4, md: 16 }}
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        align="center"
        maxW="7xl"
        mx="auto"
        gap={{ base: 8, md: 16 }}
      >
        {/* Texts */}
        <VStack align="start" spacing={6} flex={1}>
          <Heading
            as="h2"
            size="xl"
            bgGradient="linear(to-r, teal.400, blue.500)"
            bgClip="text"
          >
            {title}
          </Heading>
          <Text fontSize="xl" color="gray.600">
            {subtitle}
          </Text>
          <Text fontSize="md" color="gray.500">
            {description}
          </Text>
          {ctaText && ctaLink && (
            <Button
              colorScheme="blue"
              size="lg"
              as="a"
              href={ctaLink}
              target="_blank"
              rel="noopener noreferrer"
              textDecoration= "none"
              _hover={{ bg: "blue.400", textDecoration: "none" }}
            >
              {ctaText}
            </Button>
          )}
        </VStack>

        {/* YouTube Video */}
        <Box
          flex={1}
          borderRadius="xl"
          overflow="hidden"
          shadow="lg"
          w="100%"
          h={{ base: "200px", md: "400px" }}
        >
          <iframe
            width="100%"
            height="100%"
            src={videoUrl}
            title="YouTube video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </Box>
      </Flex>
    </Box>
  );
};

export default VideoSection;
